import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-200 p-4 mt-auto">
      <div className="container mx-auto text-center">
        <p>&copy; {new Date().getFullYear()} Caner Irfanoglu</p>
      </div>
    </footer>
  );
}

export default Footer;
